/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState } from 'react';

import { CountDownSpinnerModal } from '../Modals/CountDownSpinnerModal/CountDownSpinnerModal';

export namespace WaitAfterSigningModal {
  export interface OwnProps {
    isOpen: boolean;
    setIsDismissed: (isDismissed: boolean) => void;
  }
}

/**
 * After a document is fully signed, we need to wait to be notified that
 * the updated signed PDF is available so that we can display the updated PDF and take any
 * necessary further action (ex: notarize the doc). While we're waiting for that event,
 * we show a "waiting" modal.
 */
export const WaitAfterSigningModal: React.FC<WaitAfterSigningModal.OwnProps> = ({ isOpen, setIsDismissed }) => {
  const [close, setClose] = useState(() => () => {});

  return (
    <CountDownSpinnerModal
      heading="Saving document changes"
      description="If this document does not update in 2 minutes, you may need to end the appointment and reschedule."
      countDownSeconds={120}
      isOpen={isOpen}
      contentLabel="Wait after signing"
      handleClose={close}
      onTimerEnds={() => {
        setClose(() => () => {
          setIsDismissed(true);
        });
      }}
    />
  );
};
